// project import
import userAdmin from './userAdmin';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  userAdmin
};

export default menuItems;
